module.exports = __webpack_public_path__ + "img/tool-539.c386455.webp";